export default "__VITE_ASSET__Dvp6iLke__"